export default "__VITE_ASSET__JURSnWZN__"